import React, { useState } from 'react'
import TopNav from 'components/Navbar/TopNav';
import SideNav from 'components/Navbar/SideNav';

function AppLayout({ children }) {

    const [sideMenu, setSideMenu] = useState(false)

    return (
        <main className="flex flex-column">
            <TopNav sideMenu={sideMenu} setSideMenu={setSideMenu} />
            <div className="flex flex-fit">
                <SideNav sideMenu={sideMenu} setSideMenu={setSideMenu} />
                {children}
            </div>
        </main>
    )
}

export default AppLayout